<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-left py-0 my-10">
        <h2 class="fs-1x fw-bolder mb-10">{{ titulo }} de Usuario</h2>

        <div class="row" v-if="!edicion">
          <div class="col-md-6">
            <p class="round3">
              Los campos marcados con (<span style="color: red"> * </span>) son
              de llenado obligatorio.
            </p>
          </div>
        </div>

        <input type="hidden" v-model="state.formData.id_persona" />
        <input type="hidden" v-model="state.formData.id_usuario" />
        <input type="hidden" v-model="state.formData.genero" />
        <input type="hidden" v-model="state.formData.localidad" />
        <input type="hidden" v-model="state.formData.imagen_segip" />

        <div class="row">
          <div class="col-md-4 mt-3">
            <label class="form-label required">Numero de Documento:</label>
            <input
              type="number"
              class="form-control fuente"
              style="text-transform: uppercase"
              ref="nro_documento"
              id="nro_documento"
              v-model="state.formData.nro_documento"
            />
            <span class="text-danger" v-if="v$.formData.nro_documento.$error">
              Número de Documento requerido
            </span>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Complemento:</label>
            <input
              type="text"
              class="form-control fuente"
              style="text-transform: uppercase"
              id="complemento"
              v-model="state.formData.complemento"
            />
          </div>
          <div class="col-md-4 col-sm-12 mt-4">
            <button
              type="button"
              style="margin: 5px"
              class="btn px-3"
              @click="searchSegipData()"
            >
              <i
                title="Realizar búsqueda"
                style="font-size: 1.5em; color: Dodgerblue"
                class="fas fa-magnifying-glass"
              ></i>
            </button>
            <button
              type="button"
              style="margin: 10px"
              class="btn px-3"
              @click="resetSegipData()"
            >
              <i
                title="Vaciar campos"
                style="font-size: 1.5em; color: red"
                class="fas fa-trash"
              ></i>
            </button>
          </div>
        </div>

        <!-- <div class="row" v-if="edicion"> -->
        <div class="row">
          <div class="col-md-12">
            <img
              :src="state.formData.imagen_segip"
              class="img-fluid img-thumbnail rounded mx-auto d-block"
              width="150"
              height="150"
              alt="SegipImage"
            />
          </div>
        </div>
        <!-- <div class="row" v-if="edicion"> -->
        <div class="row">
          <div class="col-md-4 mt-3">
            <label class="form-label">Nombres:</label>
            <div class="form-control fuente" v-if="state.formData.nombres">
              {{ state.formData.nombres }}
            </div>
            <div class="form-control fuente" v-else>&nbsp;</div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Apellido Paterno:</label>
            <div
              class="form-control fuente"
              v-if="state.formData.primer_apellido"
            >
              {{ state.formData.primer_apellido }}
            </div>
            <div class="form-control fuente" v-else>&nbsp;</div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Apellido Materno:</label>
            <div
              class="form-control fuente"
              v-if="state.formData.segundo_apellido"
            >
              {{ state.formData.segundo_apellido }}
            </div>
            <div class="form-control fuente" v-else>&nbsp;</div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Género:</label>
            <div class="form-control fuente" v-if="state.formData.genero">
              {{ state.formData.genero }}
            </div>
            <div class="form-control fuente" v-else>&nbsp;</div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Fecha de Nacimiento:</label>
            <div class="form-control fuente">
              {{
                state.formData.fecha_nacimiento
                  ? format(state.formData.fecha_nacimiento)
                  : "-"
              }}
            </div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Departamento:</label>
            <div class="form-control fuente" v-if="state.formData.departamento">
              {{ state.formData.departamento }}
            </div>
            <div class="form-control fuente" v-else>&nbsp;</div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Provincia:</label>
            <div class="form-control fuente" v-if="state.formData.provincia">
              {{ state.formData.provincia }}
            </div>
            <div class="form-control fuente" v-else>&nbsp;</div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Localidad:</label>
            <div class="form-control fuente" v-if="state.formData.localidad">
              {{ state.formData.localidad }}
            </div>
            <div class="form-control fuente" v-else>&nbsp;</div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Direccion:</label>
            <div class="form-control fuente" v-if="state.formData.direccion">
              {{ state.formData.direccion }}
            </div>
            <div class="form-control fuente" v-else>&nbsp;</div>
          </div>
        </div>
        <!-- <hr v-if="edicion"> -->
        <div class="row">
          <!-- <div class="col-md-4 mt-3" v-if="edicion"> -->
          <div class="row mt-3">
            <label class="form-label">Roles:</label>
            <div class="col-md-4" v-for="rol in rolesList" :key="rol.id_rol">
              <div class="form-check mt-1">
                <label class="form-check-label">
                  <input
                    type="radio"
                    class="form-check-input"
                    ref="roles"
                    :value="rol.id_rol"
                    v-model="state.formData.roles"
                    :onchange="rolSelected(state.formData.roles)"
                  />{{ rol.nombre_rol.toUpperCase() }}
                </label>
              </div>
            </div>
          </div>
          <span class="text-danger" v-if="v$.formData.roles.$error">
            Debe asignar un Rol
          </span>
          <div v-if="findRol" class="col-md-4 mt-3">
            <label class="form-label required"
              >Departamento a Supervisar:</label
            >
            <select
              v-model="state.formData.departamento_supervisar"
              class="form-select fuente"
              aria-label="select"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in departmentsList"
                :value="list.departamento"
                :key="key"
              >
                {{ list.departamento }}
              </option>
            </select>
            <div
              class="input-errors"
              v-for="error of v$.formData.departamento_supervisar.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Departamento a supervisar requerido</span
              >
            </div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label required">Número Celular:</label>
            <input
              type="number"
              class="form-control fuente"
              ref="telefono_movil"
              id="telefono_movil"
              v-model="state.formData.telefono_movil"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.telefono_movil.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Número Celular requerido</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'minLength'"
                >Cantidad de dígitos mínima 8</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'maxLength'"
                >Cantidad de dígitos máxima 8</span
              >
            </div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label required">Institución:</label>
            <select
              class="form-select fuente"
              id="institucion_pertenece"
              ref="institucion_pertenece"
              aria-label="select"
              v-model="state.formData.institucion_pertenece"
            >
              <option value="POLICIA BOLIVIANA">POLICIA BOLIVIANA</option>
              <option value="ADMINISTRACIÓN DGRP">ADMINISTRACIÓN DGRP</option>
            </select>
            <span
              class="text-danger"
              v-if="v$.formData.institucion_pertenece.$error"
            >
              Institución requerida
            </span>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label required">Cargo:</label>
            <input
              type="text"
              class="form-control fuente"
              ref="cargo"
              id="cargo"
              style="text-transform: uppercase"
              v-model="state.formData.cargo"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.cargo.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Cargo requerido</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'minLength'"
                >Debe tener al menos 6 caracteres</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'maxLength'"
                >Máximo aceptado de 20 caracteres</span
              >
            </div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label required">Recinto Penitenciario:</label>
            <select
              class="form-select fuente"
              ref="recinto_penitenciario"
              aria-label="select"
              v-model="state.formData.recinto_penitenciario"
              :disabled="disabledPenitentiary"
            >
              <option
                :value="recinto_penitenciario.id_recinto_penitenciario"
                v-for="recinto_penitenciario in penitentiariesList"
                :key="recinto_penitenciario.id_recinto_penitenciario"
              >
                {{ recinto_penitenciario.nombre_recinto_penitenciario }}
              </option>
            </select>
            <span
              class="text-danger"
              v-if="v$.formData.recinto_penitenciario.$error"
            >
              Recinto penitenciario requerido
            </span>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label required">Correo Institucional:</label>
            <input
              type="email"
              class="form-control fuente"
              ref="correo_electronico"
              id="correo_electronico"
              v-model="state.formData.correo_electronico"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.correo_electronico.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Correo Institucional requerido</span
              >
              <span class="text-danger" v-else-if="error.$validator == 'email'"
                >Correo Institucional invalido</span
              >
            </div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label required">Nombre de Usuario:</label>
            <input
              type="text"
              class="form-control fuente"
              ref="nombre_usuario"
              id="nombre_usuario"
              v-model="state.formData.nombre_usuario"
            />
            <span class="text-danger" v-if="v$.formData.nombre_usuario.$error">
              Nombre de Usuario requerido
            </span>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label required">Contraseña:</label>
            <input
              :type="type"
              class="form-control fuente"
              ref="contrasena"
              id="contrasena"
              v-model="state.formData.contrasena"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.contrasena.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Contraseña requerida</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'minLength'"
                >Debe tener al menos 8 caracteres</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'maxLength'"
                >Máximo aceptado de 20 caracteres</span
              >
            </div>
          </div>
          <div class="col-md-4 mt-12">
            <div class="form-check mb-5">
              <input
                class="form-check-input mb-5"
                type="checkbox"
                value=""
                id="flexCheckDefault"
                @click="showPassword"
              />
              <label class="form-check-label" for="flexCheckDefault">
                Mostrar contraseña
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-center">
            <button
              type="button"
              class="btn btn-danger px-4 mx-3"
              @click="back"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-success px-4 mx-3"
              @click="submitButton"
            >
              {{ boton }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  computed,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import useVuelidate from "@vuelidate/core";
import formatDate from "@/helpers/formatDate";
import {
  required,
  email,
  minLength,
  maxLength,
  requiredIf,
} from "@vuelidate/validators";
// import { init } from '@emailjs/browser';
// init("p67H4_2OpZ76taA2P");
// import emailjs from 'emailjs-com';
import user from "@/user/composables/useUser";
export default defineComponent({
  name: "readUser",
  components: {},
  setup() {
    const router = useRouter();
    const departmentsList = ref([]);
    const provincesList = ref([]);
    const penitentiariesList = ref([]);
    const rolesList = ref([]);
    const rolesUserList = ref([]);

    const nro_documento = ref(null);
    const telefono_movil = ref(null);
    const institucion_pertenece = ref(null);
    const cargo = ref(null);
    const recinto_penitenciario = ref(null);
    const correo_electronico = ref(null);
    const nombre_usuario = ref(null);
    const contrasena = ref(null);
    const roles = ref("");
    let titulo = "Registro";
    let boton = "Registrar";
    let edicion = false;
    const type = ref("password");
    const showPassword = () => {
      if (type.value === "password") {
        type.value = "text";
      } else {
        type.value = "password";
      }
    };
    const state = reactive({
      formData: {
        departamento_supervisar: "",
        perfil: false,
        id_persona: "",
        id_usuario: "",
        nro_documento: "",
        complemento: "",
        genero: "",
        fecha_nacimiento: "",
        nombres: "",
        primer_apellido: "",
        segundo_apellido: "",
        pais: "",
        departamento: "",
        provincia: "",
        localidad: "",
        direccion: "",
        telefono_movil: "",
        imagen_segip:
          "https://eitrawmaterials.eu/wp-content/uploads/2016/09/person-icon.png",

        institucion_pertenece: "",
        cargo: "",
        recinto_penitenciario: "",
        nombre_usuario: "",
        contrasena: "",
        correo_electronico: "",
        roles: "",
      },
    });

    const {
      searchSegip,
      nameDepartments,
      nameProvinces,
      namePenitentiaries,
      nameRoles,
      createUser,
      infoUser,
      infoRolesUser,
      infoPasswordUser,
      updateUser,
      sendMail,
    } = user();
    const format = (date) => {
      const formattedDate = formatDate(date);
      return formattedDate;
    };
    const setUserInformation = async () => {
      const { data } = await infoUser(router.currentRoute.value.params.id);
      // console.log('Informacion de db', data)
      // CONFIGURACION DEL TEXTO DE DATE
      state.formData.departamento_supervisar = data.departamento_supervisar;
      state.formData.id_persona = data.id_persona;
      state.formData.id_usuario = data.id_usuario;
      state.formData.nro_documento = data.nro_documento;
      state.formData.complemento = data.complemento;
      state.formData.genero = data.genero;
      state.formData.fecha_nacimiento = data.fecha_nacimiento;
      state.formData.nombres = data.nombres;
      state.formData.primer_apellido = data.primer_apellido;
      state.formData.segundo_apellido = data.segundo_apellido;
      state.formData.pais = data.pais;
      state.formData.departamento = data.departamento;
      state.formData.provincia = data.provincia;
      state.formData.localidad = data.localidad;
      state.formData.direccion = data.direccion;
      state.formData.telefono_movil = data.telefono_movil;
      if (data.imagen_segip) {
        state.formData.imagen_segip = data.imagen_segip;
      } else {
        // state.formData.imagen_segip = "../../../public/media/blank.png"
        state.formData.imagen_segip =
          "https://eitrawmaterials.eu/wp-content/uploads/2016/09/person-icon.png";
      }

      state.formData.institucion_pertenece = data.institucion_pertenece;
      state.formData.cargo = data.cargo;
      state.formData.recinto_penitenciario = data.id_recinto_penitenciario;
      state.formData.nombre_usuario = data.nombre_usuario;
      state.formData.correo_electronico = data.correo_electronico;

      listNameProvinces(data.departamento);
      listRolesUser(data.id_usuario);
      dataPasswordUser(data.id_usuario);
    };

    // EVALUACION REGISTRO/EDICION
    if (router.currentRoute.value.params.id != "0") {
      titulo = "Edición";
      boton = "Actualizar";
      edicion = true;
      setUserInformation();
    }

    const birthDate = (date) => {
      if (date !== undefined) {
        let format = date.split("/");
        let lastFormat = format[2] + "-" + format[1] + "-" + format[0];
        lastFormat = new Date(lastFormat + "T04:00:00Z");
        return lastFormat;
      }
      return "";
    };

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    });

    // SELECT DEPARTAMENTOS
    const listNameDepartments = async () => {
      const { data } = await nameDepartments();
      departmentsList.value = data;
    };

    // SELECT PROVINCIAS
    const listNameProvinces = async (nameDepartment) => {
      const { data } = await nameProvinces(nameDepartment);
      provincesList.value = data;
    };

    // SELECT RECINTOS PENITENCIARIOS
    const listNamePenitentiaries = async () => {
      const { data } = await namePenitentiaries();
      penitentiariesList.value = data;
    };

    // LISTA CHECKBOX ROLES
    const listNameRoles = async () => {
      const { data } = await nameRoles();
      rolesList.value = data;
    };

    // LISTA ROLES USUARIO PARA CHECKBOX - EDICION
    const listRolesUser = async (idUsuario) => {
      // console.log(idUsuario)
      const { data } = await infoRolesUser(idUsuario);
      for (let d of data) {
        // console.log(d)
        state.formData.roles = d.id_rol;
      }
      // rolesUserList.value = data
      // console.log(rolesUserList.value)
    };

    // CONTRASENA DE USUARIO
    const dataPasswordUser = async (idUsuario) => {
      const { data } = await infoPasswordUser(idUsuario);
      state.formData.contrasena = data.data;
    };
    const findRol = ref(false);
    const disabledPenitentiary = ref(false);
    const rolSelected = (value) => {
      const found = rolesList.value.find((element) => element.id_rol === value);
      if (found !== undefined) {
        if (
          found.nombre_rol !== "supervisor" &&
          found.nombre_rol !== "consultas departamentales"
        ) {
          state.formData.departamento_supervisar = "";
          if (
            found.nombre_rol === "admin" ||
            found.nombre_rol === "editor" ||
            found.nombre_rol === "consultas nacional"
          ) {
            const found = penitentiariesList.value.find(
              (element) => element.nombre_recinto_penitenciario === "TODOS"
            );
            state.formData.recinto_penitenciario =
              found.id_recinto_penitenciario;
            disabledPenitentiary.value = true;
          } else if (found.nombre_rol === "filiador") {
            disabledPenitentiary.value = false;
          }
          findRol.value = false;
        } else {
          findRol.value = true;
          disabledPenitentiary.value = true;
          state.formData.recinto_penitenciario = "";
        }
      } else {
        return null;
      }
    };
    // const findRol = computed(() => {
    //   const found = rolesList.value.find(
    //     (element) => element.nombre_rol === "supervisor"
    //   );
    //   if (found !== undefined) {
    //     let isSup = state.formData.roles === found.id_rol;
    //     return isSup;
    //   } else {
    //     return null;
    //   }
    // });
    // watch(findRol, (value) => {
    //   console.log(value);
    //   if (value) {
    //     state.formData.recinto_penitenciario = "";
    //   }
    // });
    // VALIDACIONES
    const rules = computed(() => {
      return {
        formData: {
          nro_documento: { required },
          telefono_movil: {
            required,
            minLength: minLength(8),
            maxLength: maxLength(8),
          },
          institucion_pertenece: { required },
          cargo: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(50),
          },
          departamento_supervisar: {
            required: requiredIf(function () {
              return findRol.value;
            }),
          },
          recinto_penitenciario: {
            required: requiredIf(function () {
              return !findRol.value;
            }),
          },
          correo_electronico: { required, email },
          nombre_usuario: { required },
          contrasena: {
            required,
            minLength: minLength(8),
            maxLength: maxLength(20),
          },
          roles: { required },
        },
      };
    });
    const v$ = useVuelidate(rules, state);

    // BOTON BUSQUEDA INFORMACION SEGIP
    const searchSegipData = async () => {
      //console.log(state.formData.nro_documento.length)
      // SI NO EXISTE INFORMACION EN EL CAMPO NRO_DOCUMENTO
      // if (state.formData.nro_documento.length != undefined) {
      //   Toast.fire({
      //     icon: "error",
      //     title: "Ingresar número de documento.",
      //   });
      // } else {
      const { data } = await searchSegip(state.formData);
      if (data.NumeroDocumento == undefined) {
        Toast.fire({
          icon: "error",
          title: "No se encontraron coincidencias.",
        });
      } else {
        Toast.fire({
          icon: "success",
          title: "Resultado obtenido satisfactoriamente.",
        });
        state.formData.genero = data.Genero;
        state.formData.fecha_nacimiento = birthDate(data.FechaNacimiento);
        state.formData.nombres = data.Nombres;
        state.formData.primer_apellido = data.PrimerApellido;
        state.formData.segundo_apellido = data.SegundoApellido;
        state.formData.pais = data.LugarNacimientoPais;
        state.formData.departamento = data.LugarNacimientoDepartamento;
        listNameProvinces(state.formData.departamento);
        state.formData.provincia = data.LugarNacimientoProvincia;
        state.formData.localidad = data.LugarNacimientoLocalidad;
        state.formData.direccion = data.Domicilio;
        state.formData.imagen_segip =
          data.Fotografia !== undefined
            ? "data:image/jpeg;base64," + data.Fotografia
            : "https://eitrawmaterials.eu/wp-content/uploads/2016/09/person-icon.png";
        // AQUI GENERAMOS DE FORMA AUTOMATICA EL USUARIO Y CONTRASENHA
        state.formData.nombre_usuario = data.NumeroDocumento;
        state.formData.contrasena = generateRandomPassword();
      }
      //}
    };

    // GENERACIÓN DE CONTRASENA ALEATORIA
    const generateRandomPassword = () => {
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ+-*_0123456789";
      let passwordGenerated = "";
      for (let index = 0; index < 8; index++) {
        passwordGenerated += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }
      return passwordGenerated;
    };

    // BOTON RESET FORMULARIO
    const resetSegipData = () => {
      state.formData.departamento_supervisar = "";
      state.formData.nro_documento = "";
      state.formData.complemento = "";
      state.formData.genero = "";
      state.formData.fecha_nacimiento = "";
      state.formData.nombres = "";
      state.formData.primer_apellido = "";
      state.formData.segundo_apellido = "";
      state.formData.pais = "";
      state.formData.departamento = "";
      state.formData.provincia = "";
      state.formData.localidad = "";
      state.formData.direccion = "";
      state.formData.imagen_segip =
        "https://eitrawmaterials.eu/wp-content/uploads/2016/09/person-icon.png";

      state.formData.telefono_movil = "";
      state.formData.institucion_pertenece = "";
      state.formData.cargo = "";
      state.formData.recinto_penitenciario = "";
      state.formData.correo_electronico = "";
      state.formData.nombre_usuario = "";
      state.formData.contrasena = "";
      state.formData.roles = "";
    };

    // BOTON CANCELAR
    const back = () => {
      router.push({ name: "listUser" });
    };

    // BOTON REGISTRAR
    const submitButton = async () => {
      v$.value.$validate();
      if (!v$.value.$error) {
        let data;
        // PARSEO DE VARIABLES DEL FORMULARIO
        state.formData.nombres = state.formData.nombres
          .replace(/['`"]+/g, "")
          .toUpperCase();
        state.formData.primer_apellido = state.formData.primer_apellido
          .replace(/['`"]+/g, "")
          .toUpperCase();
        state.formData.segundo_apellido = state.formData.segundo_apellido
          .replace(/['`"]+/g, "")
          .toUpperCase();
        state.formData.provincia
          ? state.formData.provincia.replace(/['`"]+/g, "").toUpperCase()
          : "";
        state.formData.localidad = state.formData.localidad
          .replace(/['`"]+/g, "")
          .toUpperCase();
        state.formData.direccion = state.formData.direccion
          .replace(/['`"]+/g, "")
          .toUpperCase();
        state.formData.cargo = state.formData.cargo
          .replace(/['`"]+/g, "")
          .toUpperCase();

        state.formData.correo_electronico =
          state.formData.correo_electronico.replace(/['`"]+/g, "");
        state.formData.nombre_usuario = state.formData.nombre_usuario.replace(
          /['`"]+/g,
          ""
        );
        state.formData.contrasena = state.formData.contrasena.replace(
          /['`"]+/g,
          ""
        );

        // REDIRECCIONAMIENTO
        if (router.currentRoute.value.params.id != "0") {
          // console.log('enviar a update', state.formData)
          data = await updateUser(state.formData);
        } else {
          // console.log('enviar a create', state.formData)
          data = await createUser(state.formData);
        }

        // ALERTAS
        if (data.data) {
          Toast.fire({
            icon: "success",
            title: data.data.message,
          });
          router.push({ name: "listUser" });
        } else {
          Toast.fire({
            icon: "error",
            title: data.message.response.data,
          });
        }
      } else {
        // DEVUELVE LOS CAMPOS QUE FALTAN
        const expr = v$.value.$errors[0].$property;
        switch (expr) {
          case "nro_documento":
            nro_documento.value.focus();
            break;
          case "telefono_movil":
            telefono_movil.value.focus();
            break;
          case "institucion_pertenece":
            institucion_pertenece.value.focus();
            break;
          case "cargo":
            cargo.value.focus();
            break;
          case "recinto_penitenciario":
            recinto_penitenciario.value.focus();
            break;
          case "correo_electronico":
            correo_electronico.value.focus();
            break;
          case "nombre_usuario":
            nombre_usuario.value.focus();
            break;
          case "contrasena":
            contrasena.value.focus();
            break;
        }
      }
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs(`${titulo} de usuario`, ["Usuarios"]);
      listNameDepartments();
      listNamePenitentiaries();
       listNameRoles();
    });

    return {
      titulo,
      boton,
      edicion,
      state,
      v$,
      format,

      listNameDepartments,
      listNameProvinces,
      listNamePenitentiaries,
      listNameRoles,
      listRolesUser,

      departmentsList,
      provincesList,
      penitentiariesList,
      rolesList,
      rolesUserList,

      searchSegipData,
      resetSegipData,
      submitButton,
      back,

      nro_documento,
      telefono_movil,
      institucion_pertenece,
      cargo,
      recinto_penitenciario,
      correo_electronico,
      nombre_usuario,
      contrasena,
      roles,
      showPassword,
      type,
      findRol,
      disabledPenitentiary,
      rolSelected,
    };
  },
});
</script>

<style>
.fuente {
  font-size: 0.97em;
  padding: 0.35em;
  font-weight: normal;
}
</style>
